import React, { useState } from 'react';
import { Button, MenuItem, Paper, Stack, TextField, Typography } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { launchColors } from '../launchTheme';

export const BULK_FIELDS = ['action', 'info', 'commentKam', 'samples', 'category'] as const;
export type BulkField = typeof BULK_FIELDS[number];

const LABELS: Record<BulkField, string> = {
  action: 'Åtgärd',
  info: 'Info',
  commentKam: 'Kommentar KAM',
  samples: 'Varuprover',
  category: 'Kategori',
};

interface Props {
  count: number;
  busy: boolean;
  onApply: (field: BulkField, value: string) => void;
  onDelete: () => void;
  onClear: () => void;
  onCopyEan: () => void;
}

const BulkEditBar: React.FC<Props> = ({ count, busy, onApply, onDelete, onClear, onCopyEan }) => {
  const [field, setField] = useState<BulkField>('action');
  const [value, setValue] = useState('');
  return (
    <Paper
      elevation={8}
      role="region"
      aria-label="Ändra valda rader"
      sx={{ position: 'sticky', bottom: 16, zIndex: 5, px: 2, py: 1.5, borderRadius: '12px', bgcolor: launchColors.softNavy, border: `1px solid ${launchColors.navy}` }}
    >
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={1.5} alignItems={{ md: 'center' }}>
        <Typography sx={{ fontWeight: 700, color: launchColors.navy, whiteSpace: 'nowrap' }}>{`${count} ${count === 1 ? 'rad vald' : 'rader valda'}`}</Typography>
        <TextField
          select
          size="small"
          label="Fält"
          value={field}
          onChange={(event) => setField(event.target.value as BulkField)}
          sx={{ minWidth: 170, '& .MuiInputBase-root': { bgcolor: launchColors.card } }}
        >
          {BULK_FIELDS.map((item) => <MenuItem key={item} value={item}>{LABELS[item]}</MenuItem>)}
        </TextField>
        <TextField
          size="small"
          label="Nytt värde"
          value={value}
          placeholder="Lämna tomt för att rensa"
          onChange={(event) => setValue(event.target.value)}
          inputProps={{ maxLength: field === 'category' ? 80 : 500 }}
          InputLabelProps={{ shrink: true }}
          sx={{ flex: 1, minWidth: 200, '& .MuiInputBase-root': { bgcolor: launchColors.card } }}
        />
        <Button variant="contained" disabled={busy || count === 0 || (field === 'category' && !value.trim())} onClick={() => onApply(field, value)}>
          Använd
        </Button>
        <Button startIcon={<ContentCopyIcon />} disabled={count === 0} onClick={onCopyEan} sx={{ whiteSpace: 'nowrap' }}>Exportera EAN-kod till urklipp</Button>
        <Button color="error" disabled={busy || count === 0} onClick={onDelete}>Radera</Button>
        <Button onClick={onClear}>Avmarkera</Button>
      </Stack>
    </Paper>
  );
};

export default BulkEditBar;
